import React from 'react';

interface ActionButtonsProps {
  index: number;
  editingIndex: number | null;
  setEditingIndex: (index: number | null) => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  index,
  editingIndex,
  setEditingIndex,
}) => (
  <div className="d-flex flex-column gap-2 w-100">
    <div className="d-flex gap-2 flex-column flex-xl-row">
      <button className="btn btn-outline-primary w-100" 
    //   onClick={() => onVerify(index)}
      >
        Verify
      </button>
      <button className="btn btn-outline-info w-100" 
    //   onClick={() => onUpdate(index)}
      >
        Update
      </button>
    </div>
    <textarea
      className="form-control"
      placeholder="Add comment"
    //   value={comment}
    //   onChange={e => onCommentChange(index, e.target.value)}
    />
    <button className="btn btn-success"
    //  onClick={() => onSubmit(index)}
     >
      Submit
    </button>
  </div>
);

export default ActionButtons;